module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/logo-coj-zh-hant-2b7e61bd0b89ff457ec507dba5a5bbcd.svg";